import { segment } from "./client"
import { type UserProfile } from "@/types/userTypes"
import { $launchDarklyFlags } from "@/stores/launchDarkly"

const createSegmentIdentity = (user: UserProfile) => {
  return {
    id: String(user.id),
    email: user.email,
    first_name: user.firstName,
    last_name: user.lastName,
    photo: user.photo,
    birthdate: user.birthdate,
    phone_number: user.phoneNumber,
    flips: user.loanProfile?.propertiesFlipped || 0,
    rentals: user.loanProfile?.rentalsOwned || 0,
    beta_user: user.betaUser,
    is_verified: user.isVerified,
    referral_code: user.referralCode,
    feature_flags: $launchDarklyFlags.get(),
  }
}

export const identify = async (user: UserProfile) => {
  const identity = createSegmentIdentity(user)
  await segment.identify(identity.id, identity)
}

export const anonymousIdentify = async () => {
  await segment.identify(undefined, { feature_flags: $launchDarklyFlags.get() })
}

export const reset = async () => {
  await segment.reset(false)
}
